import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const schedulesOutOfDate = api(({ regimeId, skip, take, search }) =>
    query(
        gql`
            query SchedulesOutOfDate($regimeId: String!, $take: Int, $skip: Int, $search: String) {
                schedulesOutOfDateForRegime(regimeId: $regimeId, search: $search) {
                    id
                    total
                    items(skip: $skip, take: $take) {
                        idOfScheduleInRegime
                        scheduleId
                        title
                        code
                        where
                        sfg20Version
                        regimeVersion
                    }
                }
            }
        `,
        {
            regimeId,
            skip,
            take,
            search,
        },
        {
            returns: "schedulesOutOfDateForRegime",
        }
    )
)
